import { WSService } from "../../../utils/WSService";

export const planEnrollmentService = new WSService("/v2/plan-enrollment");
